import { PLBTypes } from "enums";

export const accountListFilterState = (searchKey) => ({
  startDate: null,
  endDate: null,
  searchKey: searchKey || "",
  status: "all",
  accountType: "all",
  plbType: {
    isSelectedAll: true,
    value: [PLBTypes.PLB_HEDGING, PLBTypes.PLB_LOCQPAY, PLBTypes.PLB_LOCQPAY_MANUAL_PO, PLBTypes.PLB_LOCQPAY_MANUAL_PO_CREDIT],
  },
  page: 1,
  perPage: 10,
});
